import React from "react";
import {Typography} from "@mui/material";

import {buildHealthIndicatorIcon, buildSessionHealthColor} from "../../../helpers/HealthIndicatorBuilder";
import {CenteredBox, ColoredAvatar} from "../../themes/styled";

export default function SessionBookedHealth({session, state}) {

    const backgroundColor = buildSessionHealthColor[state];
    const icon = buildHealthIndicatorIcon("session-booked");

    return (
      <CenteredBox>
          <ColoredAvatar background={backgroundColor}>{icon}</ColoredAvatar>
          <Typography variant="body2">Session booked</Typography>
      </CenteredBox>
    );
}